module.exports = __webpack_public_path__ + "static/img/no-data.e9d1ef89.png";